export enum ComposeSnapshotStatus {
  DIRTY = 'DIRTY',
}
